// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchHint_container__1oEbT","icon":"SearchHint_icon__24dmi","title":"SearchHint_title__6Amqm","subtitle":"SearchHint_subtitle__1KwrF"};